import { useUserState } from "../../context/UserContext";
// import Layout from "../../components/Layout";
import AuditTrail from "./admin/index";

const index = () => {
  const { userRole } = useUserState();

  return (
    <>
      {userRole?.role === "school_admin" ? (
        <AuditTrail />
      ) : null}
    </>
  );
};

export default index;
